export type JMSDRIVER = 'Mongo' | 'SQL';

export enum TenantStatus {
    Created = 'Created',// 'Tenant is created',
    Confirmed = 'Confirmed',// 'Tenant is confirmed',
    Initializing = 'Initializing',// 'Tenant is initiating data',
    Initialized = 'Initialized',// 'Tenant is initiated data',
    Ready = 'Ready'// 'Tenant is using'
}

export enum TenantSubscription {
    System = 'System',
    Core = 'Core',
    Professional = 'Professional',
    Enterprise = 'Enterprise',
    Developer = 'Developer',
    Custom = 'Custom'
}

export interface TenantInvitation {
    _id: string;
    url: string;
    email: string;
    inviteDate?: Date;
    expireDate?: Date;
    confirmedDate?: Date;
}

export interface Tenant {

    _id?: string;
    name?: string;
    url?: string;
    logo?: string;

    // timezone?: string;
    // dateFormat?: string;
    // timeFormat?: string;
    // locale?: string;

    // workDayStart?: string;
    // workDayEnd?: string;
    // workDefaultTime?: WorkDefaultTime;
    // workWeek?: DayShortName[];

    driver?: JMSDRIVER;
    showWizard?: boolean;
    wizardPage?: number;

    invoiceLines?: string;
    pricing?: string;
    package?: TenantSubscription;

    electronicPayment?: boolean;
    paymentMethod?: string[];
    paymentTerm?: string;

    businessSize?: number;
    industry?: string;

    status: TenantStatus;
    trial: boolean;
    trialExpiryDate?: Date;

}
